module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-02-m-en.86d39ecdd05caed046547b68f1a2ac2b.png";